import * as React from 'react';
import { Button, ListGroup, ListGroupItem, Overlay, Popover, Sizes } from 'react-bootstrap';
import styled from 'styled-components';

export const PopoverWrapper = styled(Popover) <{ width?: number }>`
    width: ${p => p.width ? p.width + 'px' : null};

    max-width: ${p => p.width ? p.width + 'px' : null};

    & > .popover-content {
        width: ${p => p.width ? p.width - 10 + 'px' : null};
    }

    & > .arrow {
        display: ${p => p.includeArrow ? 'block' : 'none'};
    }
`;

export interface IMenuItem {
    id: any,
    action: number,
    include: boolean,
    selectable: boolean,
    divider?: boolean,
    element: JSX.Element,
    url?: string,
    title?: string
}

interface IProps {
    menu: IMenuItem[],
    bsStyle: string,
    bsSize: Sizes,
    title: string,
    includeCaret?: boolean,
    listItemStyle?: any,
    buttonTitle?: string,
    placement?: string,
    includeArrow?: boolean,
    width?: number,
    disabled?: boolean,
    onToggle?: (show: boolean) => void,
    onSelect: (id: any, action: number) => void
}

interface IState {
    show: boolean
}

class OverlayMenuButton extends React.Component<IProps, IState> {
    readonly state: IState = {
        show: false
    };

    elem: any;

    setElem = (elem: any) => this.elem = elem;

    onHide = () => this.setState({ show: false });

    onToggle = () => {
        this.setState({
            show: !this.state.show
        });

        if (this.props.onToggle) {
            this.props.onToggle(!this.state.show);
        }
    };

    onSelect = (id: any, action: number) => {
        this.setState(prevState => ({ show: !prevState.show }));
        this.props.onSelect(id, action);
    }

    renderMenu = () => {
        return (
            <ListGroup style={{ marginBottom: 0 }}>
                {this.props.menu.filter((x: any) => x.include).map((item: any) => {
                    if (item.divider == true) {
                        return (
                            <ListGroupItem key={`lgi-${item.id}-${item.action}`} className='list-group-item overlay-action-menu' style={{ ...this.props.listItemStyle, padding: 0 }}>
                                <div><hr style={{ marginTop: 9, marginBottom: 9 }} /></div>
                            </ListGroupItem>
                        );
                    }

                    if (item.selectable) {
                        return (
                            <ListGroupItem key={`lgi-${item.id}-${item.action}`} className='list-group-item overlay-action-menu' style={this.props.listItemStyle} onClick={() => this.onSelect(item.id, item.action)}>{item.element}</ListGroupItem>
                        );
                    };

                    if (item.url != null) {
                        return (
                            <a key={`lgi-${item.id}-${item.action}`} href={item.url} className='list-group-item overlay-action-menu' style={this.props.listItemStyle}>{item.element}</a>
                        );
                    }

                    return (
                        <li key={`lgi-${item.id}-${item.action}`} className='list-group-item overlay-action-menu' style={this.props.listItemStyle}>{item.element}</li>
                    );
                })}
            </ListGroup>
        )
    }

    render = () => {
        const { menu, includeCaret, title, buttonTitle } = this.props;
        const { show } = this.state;

        return (
            <div ref={this.setElem}>
                <Button
                    bsStyle={this.props.bsStyle}
                    bsSize={this.props.bsSize}
                    onClick={(e: any) => { e.stopPropagation(); this.onToggle(); }}
                    title={buttonTitle || title}
                    aria-label={buttonTitle || title || 'More actions'}
                    disabled={this.props.disabled}
                >
                    {title
                        ? <>{title}{includeCaret ? <>{' '}<span className='caret'></span></> : null}</>
                        : <span className='caret'></span>}
                </Button>
                <Overlay
                    show={show}
                    target={() => this.elem}
                    onHide={this.onHide}
                    placement={this.props.placement ? this.props.placement : 'bottom'}
                    containerPadding={40}
                    rootClose>
                    <PopoverWrapper includeArrow={this.props.includeArrow} width={this.props.width} className='overlay-menu-button' onClick={this.onHide}>
                        {this.renderMenu()}
                    </PopoverWrapper>
                </Overlay>
            </div>
        )
    }
}

export default OverlayMenuButton;